"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyToNumberStringByCountry = exports.numberToCurrencyByCountry = exports.getCurrencyPrecisionByCountry = exports.getCurrencyTypeByCountry = exports.currencyToNumber = exports.currencyToNumberString = exports.getCurrencyPrecision = exports.numberToCurrency = void 0;
var base_1 = require("./base");
var helper_1 = require("../utils/helper");
var constants_1 = require("../utils/constants");
var numberToCurrency = function (numberParam, isHighlight) {
    var result = (0, base_1.getCurrencyByPattern)(numberParam / 100);
    var _a = (0, base_1.getNumberV2)(), decimal = _a.decimal, group = _a.group;
    if (group)
        result = result.replace(',', group);
    if (decimal)
        result = result.replace(/\.(\d{1,2})$/, "".concat(decimal, "$1"));
    if (isHighlight)
        result = result.replace(new RegExp("(\\d+[\\".concat(decimal || '.', "\\").concat(group || ',', "\\d]+\\d+)")), '{$1}');
    return result.replace('¤', 'ج.م.');
};
exports.numberToCurrency = numberToCurrency;
// 获取货币精度
var getCurrencyPrecision = function () {
    return (0, base_1.getNumberV2)().precision.currency;
};
exports.getCurrencyPrecision = getCurrencyPrecision;
var currencyToNumberString = function (currency) {
    var _a = (0, base_1.getNumberV2)(), decimal = _a.decimal, group = _a.group;
    var numberMatch = currency.match(new RegExp("\\d*[\\".concat(decimal || '.', "\\").concat(group || ',', "\\d]*\\d")));
    return (/-/.test(currency) ? '-' : '') + (numberMatch ? numberMatch.join('') : '0');
};
exports.currencyToNumberString = currencyToNumberString;
var currencyToNumber = function (currency) {
    if (!/[0-9]/.test(currency))
        return currency;
    var _a = (0, base_1.getNumberV2)().decimal, decimal = _a === void 0 ? '.' : _a;
    var decimalStr = currency.match(new RegExp("\\".concat(decimal || '.', "\\d+")));
    var decimalLen = decimalStr ? decimalStr[0].length - 1 : 0;
    var matchResult = currency.match(/[-0-9]/g);
    var number = matchResult ? parseInt(matchResult.join(''), 10) : 0;
    if ((0, exports.getCurrencyPrecision)()) {
        var denominator = (0, exports.getCurrencyPrecision)() - 1;
        while (decimalLen > 0) {
            denominator *= 10;
            decimalLen--;
        }
        number /= denominator;
    }
    return number;
};
exports.currencyToNumber = currencyToNumber;
var getCurrencyTypeByCountry = function (country) {
    return constants_1.CURRENCY_MAP[country];
};
exports.getCurrencyTypeByCountry = getCurrencyTypeByCountry;
// 根据用户传入的国家码获取货币精度
var getCurrencyPrecisionByCountry = function (country) {
    (0, helper_1.validateFunction)(country, 'country', 'getCurrencyPrecisionByCountry const');
    return (0, base_1.getNumberV2ByCountry)(country).precision.currency;
};
exports.getCurrencyPrecisionByCountry = getCurrencyPrecisionByCountry;
// 根据用户传入的国家码进行数字转货币
var numberToCurrencyByCountry = function (numberParam, country, locale, isHighlight) {
    if (!country || typeof country !== 'string') {
        throw Error('Elvish Error: please call numberToCurrencyByCountry const with country parameter first');
    }
    if (!locale || typeof locale !== 'string') {
        throw Error('Elvish Error: please call numberToCurrencyByCountry const with locale parameter first');
    }
    // 获取国家对应的货币结果
    var result = (0, base_1.getCurrencyByPatternByCountry)(numberParam / 100, country, locale.replace('_', '-'));
    // 获取国家对应的 decimal 标识和 group 标识
    var _a = (0, base_1.getNumberV2ByLocale)(locale.replace('_', '-')), decimal = _a.decimal, group = _a.group;
    if (group)
        result = result.replace(',', group);
    if (decimal)
        result = result.replace(/\.(\d{2})$/, "".concat(decimal, "$1"));
    if (isHighlight && typeof isHighlight === 'boolean')
        result = result.replace(new RegExp("(\\d+[\\".concat(decimal || '.', "\\").concat(group || ',', "\\d]+\\d+)")), '{$1}');
    return result.replace('¤', 'ج.م.');
};
exports.numberToCurrencyByCountry = numberToCurrencyByCountry;
// 根据用户传入的国家码进行货币转数字字符串
var currencyToNumberStringByCountry = function (currency, locale) {
    (0, helper_1.validateFunction)(locale, 'locale', 'currencyToNumberStringByCountry const ');
    // 获取国家对应的 decimal 标识和 group 标识
    var _a = (0, base_1.getNumberV2ByLocale)(locale.replace('_', '-')), decimal = _a.decimal, group = _a.group;
    var numberMatch = currency.match(new RegExp("\\d[\\".concat(decimal || '.', "\\").concat(group || ',', "\\d]*\\d")));
    return (/-/.test(currency) ? '-' : '') + (numberMatch ? numberMatch.join('') : '0');
};
exports.currencyToNumberStringByCountry = currencyToNumberStringByCountry;
